import { IAuthentication } from './models'

export const authenticationState: IAuthentication = {
  expires: undefined,
  authorizationLevel: undefined,
  totalSecondsLeftServer: 0,
  forcedClose: false
}
export default authenticationState
